import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { useDispatch, batch } from "react-redux";
import {
  setCategory,
  setCompany,
  setDockyards,
  setEdbs,
  setProjects,
  setProducts,
  setPackageTypes,
  setCompaniesFromUser,
} from "$actions/api";

export const useAppReset = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const resetAll = useCallback(async () => {
    queryClient.clear();
    batch(() => {
      dispatch(setCompany([]));
      dispatch(setCompaniesFromUser([]));
      dispatch(setProjects([]));
      dispatch(setDockyards([]));
      dispatch(setEdbs([]));

      dispatch(setCategory([]));
      dispatch(setProducts([]));
      dispatch(setPackageTypes([]));
    });
  }, [dispatch, queryClient]);

  return {
    resetAll,
  };
};

export default useAppReset;
